export default __webpack_public_path__ + "static/media/react-bootstrap-carousel.f4133112.ttf";